import { useEffect } from 'react';
import { Spinner } from './Spinner';

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  danger = true,
  loading = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return;
    function handler(e) { if (e.key === 'Escape' && !loading) onCancel?.(); }
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, loading, onCancel]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 z-[1000] flex items-center justify-center p-4"
      onClick={!loading ? onCancel : undefined}
    >
      <div
        className="bg-white rounded-[16px] border border-[#E5E7EB] p-6 max-w-sm w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-[16px] font-bold text-[#111827] mb-2">{title}</h3>
        {message && <p className="text-[13px] text-[#6B7280] mb-6">{message}</p>}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2.5 text-[13px] text-[#6B7280] hover:text-[#374151] border border-[#E5E7EB] rounded-[8px] transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`inline-flex items-center gap-2 px-[18px] py-[9px] text-[13px] font-semibold text-white rounded-[8px] transition disabled:opacity-60 ${
              danger
                ? 'bg-[#C0392B] hover:bg-[#a93226]'
                : 'bg-[#1A4A8A] hover:bg-[#0D2240]'
            }`}
          >
            {loading && <Spinner size={13} />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
